
import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";

import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import PersonIcon from '@mui/icons-material/Person';
import FooterBar from '../../component/FooterAtom/index'
import VisibilityIcon from '@mui/icons-material/Visibility';
import Drawer from '@material-ui/core/Drawer';
import Folder1 from '../Folder/Folder'
import ReplyIcon from '@mui/icons-material/Reply';

import { useHistory } from 'react-router-dom';


import firebase from "../../config/firebase/index";
import editProfileScreen from '../Editpost/EditPost';
import Folder from '../Folder/Folder';
import MyDeals_AllBids from '../MyDeals_AllBids/MyDeals_AllBids.js';
import EditPost from '../Editpost/EditPost';

import ReactGA from 'react-ga';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import { height } from '@mui/system';
import BidsAtom from '../../component/BidsAtom/index.jsx';
var CryptoJS = require("crypto-js");


const My_Bids = () => {

    const history = useHistory();
    const classes = useStyles();
    const [deals, setDeals] = useState([]);
    const [selectedDeal, setSelectedDeal] = useState("");
    const [open, setOpen] = useState(false);
    
    const [editOpen, setEditOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const [bids, setBids] = useState([]);
    const [date, setDate] = useState(new Date());
    const [index, setIndex] = useState([]);

    const isDealer = user[0].dealerFlag;
    let show = {};

    function active(id) {

        console.log(show, show.id);

    }

    useEffect(() => {
        let PhoneNO = localStorage.getItem('Phone Number');
        console.log(PhoneNO, typeof PhoneNO);
        firebase.database().ref("Customer").orderByChild("PhoneNo")
            .equalTo(PhoneNO).on("value", snapshot => {
                console.log(":::: Suggestions :::", snapshot.val());
                let dealsData = snapshot.val();
                let customerArr = [];
                for (const key in dealsData) {
                    if (dealsData[key].method === "suggest") {
                        const dealObj = {
                            id: key,
                            ...dealsData[key],
                        };
                        customerArr.push(dealObj);
                    }

                }
                console.log("CA ::::", customerArr);
                setBids(customerArr);
            });
    }, []);


    return (
        <Grid p={2} className={classes.commonSectionBuild} style={{ paddingBottom: '30px' }}>
            <NoFollowMeta />
            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 600 }} className={classes.commonNameCenter}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;मेरी बोलियां
                </Typography>
                <IconButton onClick={() => history.push('/profile')}>

                    <PersonIcon fontSize="large" />
                </IconButton>
            </Box>
            <Typography className={classes.border}></Typography>
            {bids && bids.map((bid, index) => (
                <BidsAtom key={index} bid={bid} />
            ))}



            <Box mt={5}>
                <FooterBar isDealer={isDealer} active={[0, 0, 0, 1]} />
            </Box>

            {/* <div>
                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                        <MyDeals_AllBids closePopUp={setOpen} dealId={selectedDeal} sindex={index} />
                    </Drawer>
                </React.Fragment>
            </div>
            <div>
                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={editOpen}>
                        <EditPost closePopUp={setEditOpen} dealId={selectedDeal} date={date} />
                    </Drawer>
                </React.Fragment>
            </div> */}

        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    keematBox2: {
        background: '#eee',
        padding: 20,
        textAlign: 'center',
        boxSizing: 'border-box',
        background: '#ddd',
        width: '50%',
    },
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 30,
            borderRadius: '20px 20px 0 0',
            height: '700px',
        }
    },
    midScroll: {
        maxHeight: 'calc(100vh - 120px)',
        marginBottom: "20px",
        borderRadius: '6px',
        boxShadow: '0 10px 10px 0 #ddd',
        borderRadius: '6px',
        padding: 1,
    },
    oneByOne: {

        boxShadow: '0 0 10px #ddd',
        borderRadius: '6px',
    },
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        boxSizing: 'border-box',
        alignItems: 'center',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '40%',
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        width: '93%',
        float: 'none',
        margin: 'auto',
        // padding: '0 15px',
        boxSizing: 'border-box',

    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        alignItems: 'center',
        boxSizing: 'border-box',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    commonNameCenter: {
        alignItems: 'center',
        margin: "auto",
        size: '20px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'

    },
    keematBox: {
        background: '#eee',
        padding: 20,
        textAlign: 'center',
        boxSizing: 'border-box',

    },
    contetnArrange: {
        width: '100%',
        padding: '10px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }

    },
    saudaDekhna: {
        // marginLeft: '-30px',
    },
    contentBox: {
        background: '#fff',
        padding: 0,
        boxSizing: 'border-box',
        marginBottom: "0px",
        width: "100%",
        marginLeft: "0px",
    },

    keemat: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    keematBox1: {
        background: '#ddd',
    },
    loatBorderRight: {
        borderRight: 'solid 1px #ddd',
        width: '70% !important',

    },
    border: {
        borderBottom: 'solid 1px #ddd',

    },
    iconInFront: {
        position: 'absolute',
        right: 80,
        bottom: '13px'
    },
    rotateSHareIcon: {
        transform: 'rotateY(180deg)',
    },

}));

export default My_Bids;